export enum CancelReasonKeys {
    CancelReasoonFeedbackName = 'page.deleteAccountFeedbackPage.feedbackName',
    CancelReasoonFeedbackDetails = 'page.deleteAccountFeedbackPage.feedbackDetails',
    CancelReasoonFeedbackError = 'page.deleteAccountFeedbackPage.feedbackError',
    CancelReasoonFeedbackInactive = 'page.deleteAccountFeedbackPage.feedbackInactive',
    CancelReasoonChangeCountry = 'page.deleteAccountFeedbackPage.changeCountry'
}

export enum CancelReasonType {
    DELETE = 'delete',
}



// WEBPACK FOOTER //
// ./src/model/types/cancel-reason-type.ts